<div class="card modern-card d-flex flex-column">
  <div class="card-header border-0 bg-transparent pt-3 px-4">
    <div class="d-flex justify-content-between align-items-center">
      <div class="header-content">
        <h1 class="modern-header">Bulk Acquisition</h1>
      </div>

      <div class="header-actions">
        <button
          type="button"
          class="close-btn"
          (click)="closeClick()"
          title="Close"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="card-body p-0 d-flex flex-column flex-grow-1">
    <!-- Form -->
    <div class="body flex-grow-1 d-flex flex-column">
      <form [formGroup]="itemsForm" class="d-flex flex-column flex-grow-1">
        <!-- FFL / Customer Selection-->
        <div class="row">
          <!-- FFL/ Customer -->
          <div class="col-7">
            <!-- Select FFL -->
            @if (!isToggleOn) {
              <div class="form-group1 my-2">
                <!--[items]="sharedService.ffl_list"-->
                <label for="received_from">FFL:</label>
                <ng-select
                  [items]="sharedService.ffl_list"
                  bindLabel="ffl"
                  bindValue="id"
                  [multiple]="false"
                  [closeOnSelect]="true"
                  appendTo="body"
                  class="form-control text-uppercase input"
                  formControlName="received_from"
                  id="received_from"
                  style="width: 600px"
                  [compareWith]="compareFfls"
                >
                  <ng-template ng-label-tmp let-item="item">
                    {{ item.ffl }}
                    @if (item.legal_name) {
                      <span>-</span>
                    }
                    {{ item.legal_name }}
                    @if (item.business_name) {
                      <span>-</span>
                    }
                    {{ item.business_name }}
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    {{ item.ffl }}
                    @if (item.legal_name) {
                      <span>-</span>
                    }
                    {{ item.legal_name }}
                    @if (item.business_name) {
                      <span>-</span>
                    }
                    {{ item.business_name }}
                  </ng-template>
                </ng-select>
                <button
                  type="button"
                  class="btn btn-sm btn-primary"
                  (click)="fflSearchClick()"
                  style="margin-left: 10px"
                >
                  FFL Search
                </button>
              </div>
            }
            <!-- Select Customer -->
            @if (isToggleOn) {
              <div class="form-group1 my-2">
                <!--[items]="sharedService.ffl_list"-->
                <label for="received_from">Customer:</label>
                <ng-select
                  [items]="customers"
                  bindLabel="contact.display_name"
                  bindValue="id"
                  [multiple]="false"
                  [closeOnSelect]="true"
                  appendTo="body"
                  class="form-control text-uppercase input"
                  formControlName="received_from"
                  id="received_from"
                  style="width: 700px"
                  [compareWith]="compareCustomers"
                >
                  <ng-template ng-label-tmp let-item="item">
                    {{ item?.contact?.display_name }}
                    @if (item?.contact?.display_name) {
                      <span>-</span>
                    }
                    {{ item?.contact?.company_name }}
                    @if (item?.contact?.company_name) {
                      <span>-</span>
                    }
                    {{ item?.contact?.phone_number }}
                    @if (item?.contact?.phone_number) {
                      <span>-</span>
                    }
                    {{
                      item?.address?.street +
                        ", " +
                        item?.address?.city +
                        ", " +
                        item?.address?.state +
                        ", " +
                        item?.address?.zip_code.toString()
                    }}
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    {{ item?.contact?.display_name }}
                    @if (item?.contact?.display_name) {
                      <span>-</span>
                    }
                    {{ item?.contact?.company_name }}
                    @if (item?.contact?.company_name) {
                      <span>-</span>
                    }
                    {{ item?.contact?.phone_number }}
                    @if (item?.contact?.phone_number) {
                      <span>-</span>
                    }
                    {{
                      item?.address?.street +
                        ", " +
                        item?.address?.city +
                        ", " +
                        item?.address?.state +
                        ", " +
                        item?.address?.zip_code?.toString()
                    }}
                  </ng-template>
                </ng-select>
                <button
                  type="button"
                  class="btn btn-success"
                  (click)="customerSearchClick()"
                  style="margin-left: 10px"
                >
                  Search
                </button>
                @if (
                  this.itemsForm.get("received_from").value &&
                  this.itemsForm.get("receiver_type").value === "Customer"
                ) {
                  <button
                    type="button"
                    class="btn btn-warning"
                    (click)="EditCustomerClick()"
                    style="margin-left: 10px"
                  >
                    Edit
                  </button>
                }
              </div>
            }
          </div>
          <!-- Acquire Date-->
          <div class="col-3">
            <div class="form-group1 my-2" style="display: flex; width: 350px">
              <label for="acquisition_date" class="bold" style="width: 110px"
                >Acquired Date:</label
              >
              <input
                #date_acquired
                type="text"
                class="form-control text-uppercase input"
                formControlName="acquisition_date"
                id="acquisition_date"
                style="width: 175px"
                placeholder="__/__/__ __:__"
                [bsConfig]="bsConfig"
                [readOnly]="false"
                bsDatepicker
                autocomplete="off"
              />
              <i class="fa-solid fa-calendar calendar_icon_inside_input"></i>
            </div>
          </div>
          <!-- Toggle Switch-->
          <div class="col-2">
            <div style="margin-top: 15px; display: flex">
              <p style="margin-top: 5px; margin-right: 5px">FFL</p>
              <app-toggle-switch
                [(isChecked)]="isToggleOn"
                (click)="switchToggled()"
              ></app-toggle-switch>
              <p style="margin-top: 5px; margin-left: 5px">Customer</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group1 my-2">
            <!--[items]="sharedService.ffl_list"-->
            <label for="notes">Acquisition Notes:</label>
            <textarea
              class="form-control input"
              formControlName="notes"
              id="notes"
              style="width: 595px"
            ></textarea>
            @if (!this.importing_items) {
              <button
                type="button"
                class="btn btn-sm btn-primary float-end"
                style="width: 100px; display: inline-block; margin-left: 710px"
                (click)="addNewItemClick()"
              >
                Add UPC
              </button>
            }
          </div>
        </div>
        <div class="content-area flex-grow-1">
          <div formArrayName="items_to_acquire">
            <hr />
            @for (item of itemsToAcquire.controls; track item; let i = $index) {
              <div [formGroupName]="i">
                <div class="row">
                  <div class="col-4 form-container">
                    <div class="form-group upc">
                      <label for="upc-{{ i }}">UPC:</label>
                      <input
                        class="form-control"
                        id="upc-{{ i }}"
                        formControlName="upc"
                        (keypress)="numbersOnly($event)"
                        (input)="upcValueChanged(i, $event)"
                        (change)="upcValueSubmitted(i, $event)"
                        (paste)="upcValueSubmitted(i, $event)"
                      />
                      @if (!isUpcEmpty(i)) {
                        <i class="fa-solid fa-barcode icon_inside_input"></i>
                      }
                    </div>
                    <div class="form-group description">
                      <label for="description-{{ i }}">Description:</label>
                      <input
                        class="form-control"
                        id="description-{{ i }}"
                        formControlName="description"
                        [tooltip]="
                          itemsToAcquire.at(i).get('description').value
                        "
                      />
                    </div>
                  </div>
                  <div class="col-7">
                    <div formArrayName="serial">
                      @for (
                        serial of getSerialArray(item).controls;
                        track serial;
                        let j = $index
                      ) {
                        <div [formGroupName]="j" style="display: inline-block">
                          <div class="form-group serial">
                            <label for="serial-{{ i }}-{{ j }}"
                              >Serial {{ j + 1 }}:</label
                            >
                            @if (getSerialArray(item).controls.length > 1) {
                              <i
                                class="fa-solid fa-xmark float-end remove-serial"
                                (click)="removeSerialCLick(i, j)"
                              ></i>
                            }
                            <input
                              class="form-control"
                              id="serial-{{ i }}-{{ j }}"
                              formControlName="serial"
                              [ngClass]="{
                                'border-danger border-2':
                                  isSerialNeedingHighlight(i, j),
                              }"
                            />
                            @if (isSerialEmpty(i, j)) {
                              <i
                                class="fa-solid fa-barcode icon_inside_input"
                              ></i>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                  <div class="col-1">
                    @if (getSerialArray(item).controls.length > 2) {
                      <button
                        type="button"
                        class="btn btn-secondary btn-sm"
                        style="width: 100px"
                        (click)="createSequentialSequence(i)"
                        [disabled]="isSerialEmpty(i, 0) || isSerialEmpty(i, 1)"
                      >
                        Sequential
                      </button>
                    }
                    @if (itemsToAcquire.controls.length > 1) {
                      <button
                        type="button"
                        class="btn btn-danger btn-sm"
                        style="width: 100px; margin-top: 5px"
                        (click)="removeItemClick(i)"
                      >
                        Delete All
                      </button>
                    }
                    <button
                      type="button"
                      class="btn btn-primary btn-sm"
                      style="width: 100px; margin-top: 5px"
                      (click)="addSerial(i)"
                    >
                      Add Serial
                    </button>
                  </div>
                </div>
                <hr />
              </div>
            }
          </div>
        </div>
      </form>
    </div>
    <hr class="divider" />
    <div class="footer">
      <button
        type="button"
        class="btn btn-outline-secondary float-end"
        style="
          width: 200px;
          margin-right: 15px;
          display: inline-block;
          color: white;
        "
        [disabled]="itemsForm.invalid"
        (click)="addAllocationsClick()"
      >
        Submit Acquisitions
      </button>
    </div>
  </div>
</div>
